<ngx-headroom>
  <nav
    id="navbar-main"
    class="navbar navbar-expand-lg navbar-dark"
    style="background-color: #000005d3;"
  >
    <div class="container">
      <a class="navbar-brand mr-lg-5" [routerLink]="['/']">
        <!-- LOGO MAIN  DESKTOP-->
        <img src="../../../../../assets/img/brand/white.png" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar_global"
        aria-controls="navbar_global"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse" id="navbar_global">
        <div class="navbar-collapse-header">
          <div class="row">
            <div class="col-6 collapse-brand">
              <a [routerLink]="['/']">
                <!-- Logo MINI MOBILE COLOR -->
                <img src="../../../../../assets/img/brand/blue.png" />
              </a>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                data-toggle="collapse"
                data-target="#navbar_global"
                aria-controls="navbar_global"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <ul
          class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto"
        >
          <li class="nav-item">
            <a
              [routerLink]="['/']"
              class="nav-link"
              data-toggle="tooltip"
              role="button"
            >
              <i class="fa fa-home text-purple d-lg-none"></i>
              <span class="nav-link-inner--text">Home</span>
            </a>
          </li>

          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              class="nav-link"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-diamond text-pink d-lg-none"></i>
              <span class="nav-link-inner--text">Services</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a
                class="dropdown-item"
                [routerLink]="['/service/website-designing']"
              >
                <i class="ni ni-world-2 text-info"></i>
                Website Design
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/website-development']"
              >
                <i class="ni ni-app text-danger"></i>
                Website Development
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/ecommerce-solution']"
              >
                <i class="ni ni-palette text-primary"></i>
                E-Commerce Solution
              </a>
              <!-- <a class="dropdown-item" [routerLink]="['/service/website-designing/website-redesign']">
                                <i class="ni ni-user-run text-danger"></i>
                                Re-Design Website
                            </a> -->
              <a
                class="dropdown-item"
                [routerLink]="['/service/mobile-application']"
              >
                <i class="ni ni-paper-diploma text-purple"></i>
                Mobile Application
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/software-development']"
              >
                <i class="ni ni-money-coins text-pink"></i>
                Software Development
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/social-application']"
              >
                <i class="ni ni-chat-round text-muted"></i>
                Social Application
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/digital-marketing']"
              >
                <i class="ni ni-mobile-button text-success"></i>
                Digital Marketing
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/multimedia-solution']"
              >
                <i class="ni ni-chart-bar-32 text-default"></i>
                Multimedia Solution
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/service/web-hosting-services']"
              >
                <i class="ni ni-collection text-yellow"></i>
                Web Hosting Service
              </a>
            </div>
          </li>

          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              class="nav-link"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-diamond text-pink d-lg-none"></i>
              <span class="nav-link-inner--text">Portfolio</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/portfolio/website']">
                <i class="ni ni-world-2 text-info"></i>
                Websites
              </a>
              <a class="dropdown-item" [routerLink]="['/portfolio/apps']">
                <i class="ni ni-app text-danger"></i>
                Apps
              </a>
              <a class="dropdown-item" [routerLink]="['/portfolio/media']">
                <i class="ni ni-palette text-primary"></i>
                Graphics Design
              </a>
              <a class="dropdown-item" [routerLink]="['/portfolio/branding']">
                <i class="ni ni-user-run text-danger"></i>
                Branding
              </a>
            </div>
          </li>

          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              class="nav-link"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-tie-bow text-info d-lg-none"></i>
              <span class="nav-link-inner--text"> Packages</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a
                class="dropdown-item"
                [routerLink]="['/packages/seo-packages']"
              >
                <i class="ni ni-bullet-list-67 text-warning"></i>
                SEO Packages
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/packages/smo-packages']"
              >
                <i class="ni ni-align-center text-info"></i>
                SMO Packages
              </a>

              <a
                class="dropdown-item"
                [routerLink]="['/packages/ppc-packages']"
              >
                <i class="ni ni-money-coins text-success"></i>
                PPC Packages
              </a>

              <a
                class="dropdown-item"
                [routerLink]="['/packages/local-seo-packages']"
              >
                <i class="ni ni-square-pin text-danger"></i>
                Local SEO Packages
              </a>

              <a
                class="dropdown-item"
                [routerLink]="['/packages/static-website-packages']"
              >
                <i class="ni ni-planet text-purple"></i>
                Static Website Packages
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/packages/dynamic-website-packages']"
              >
                <i class="ni ni-chart-bar-32 text-yellow"></i>
                Dynamic Website Packages
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/packages/e-commerce-website-packages']"
              >
                <i class="ni ni-chart-bar-32 text-yellow"></i>
                E-Commerce Website Packages
              </a>
            </div>
          </li>

          <li class="nav-item dropdown">
            <a
              href="javascript:;"
              class="nav-link"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-tie-bow text-info d-lg-none"></i>
              <span class="nav-link-inner--text"> About</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/about']">
                <i class="ni ni-bullet-list-67 text-warning"></i>
                About-us
              </a>

              <a class="dropdown-item" [routerLink]="['/about/careers']">
                <i class="ni ni-money-coins text-success"></i>
                Careers
              </a>

              <a class="dropdown-item" [routerLink]="['/about/contact-us']">
                <i class="ni ni-square-pin text-danger"></i>
                Contact Us
              </a>

              <a class="dropdown-item" [routerLink]="['/about/privacy-policy']">
                <i class="ni ni-planet text-purple"></i>
                Privacy Policies
              </a>
              <a
                class="dropdown-item"
                [routerLink]="['/about/terms-and-condition']"
              >
                <i class="ni ni-chart-bar-32 text-yellow"></i>
                Terms & Conditions
              </a>
            </div>
          </li>
          <li class="nav-item">
            <a
              class="nav-link nav-link-icon login"
              [routerLink]="['/auth/login']"
              data-toggle="tooltip"
            >
              <i class="material-icons">fingerprint</i>
              <span class="nav-link-inner--text d-lg-none">Login</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</ngx-headroom>
